import React, { Component } from 'react';
export default class JobsTableColumnToggler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle_settings: window.jobs_table_column_toggle_settings
    };
    this.toggleColumn = this.toggleColumn.bind(this);
  };
  toggleColumnsToggleOptions(e) {
    e.preventDefault();
    document.getElementsByClassName(
      'columns-toggle-options'
    )[0].classList.toggle('display-block');
  }
  toggleColumn(columnTypeName) {
    let toggle_settings = {...this.state.toggle_settings};
    toggle_settings[columnTypeName] = !this.state.toggle_settings[columnTypeName];
    this.setState({toggle_settings});
    this.saveJobsTableToggleSettingsFor(columnTypeName);
    }

    saveJobsTableToggleSettingsFor(columnTypeName) {
      let url = '/api/v1/portal/jobs-table-column-toggling/'+columnTypeName;

      return fetch(
        url,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer '+window.api_token
            ,"Accept": 'application/json'
          },
        }).
      then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            toggle_settings: response,
            isLoading: false
          });
          window.jobs_table_column_toggle_settings = response;
        });
      }
    );
  }


  render() {
    let toggleSettingsJobNumber = true;
    let toggleSettingsAssignedto = true;
    let toggleSettingsCompany = true;
    let toggleSettingsOriginalCompany = true;
    let toggleSettingsSubcontractedByCompany = true;
    let toggleSettingsSubcontractedToCompany= true;
    let toggleSettingsRequiredPickup = true;
    let toggleSettingsRequiredDropoff = true;
    let toggleSettingsScheduledPickup = true;
    let toggleSettingsScheduledDropoff = true;
    let toggleSettingsReg = true;
    let toggleSettingsVehicleOnSite = true;
    let toggleSettingsCustomer = true;
    let toggleSettingsCustomerJobNumber = true;
    let toggleSettingsCustomerOrderNumber = true;
    let toggleSettingsPickupFrom = true;
    let toggleSettingsPickupTownCity = true;
    let toggleSettingsPickupPostcode = true;
    let toggleSettingsDropoffTo = true;
    let toggleSettingsDropoffTownCity = true;
    let toggleSettingsDropoffPostcode = true;
    let toggleSettingsDriver = true;
    let toggleSettingsDriverStatus = true;
    let toggleSettingsMiles = true;
    let toggleSettingsEstimatedDuration = true;
    let toggleSettingsJobPrice = true;
    let toggleSettingsDriverPrice = true;
    let toggleSettingsExpensesPrice = true;
    let toggleSettingsFuelExpensesPrice = true;
    let toggleSettingsAdminFee = true;
    let toggleSettingsG4Profit = true;
    let toggleSettingsGrossProfitPercentage = true;
    let toggleSettingsInvoiceMonth = true;
    let toggleSettingsInvoiceNumber = true;
    let toggleSettingsSubcontractInvoiceNumber = true;
    let toggleSettingsDriverDeliveredDate = true;
    let toggleSettingsConfirmedOnSite = true;
    let toggleSettingsReleaseCode = true;
    let toggleSettingsFullDetails = true;

    if (this.state.toggle_settings) {
      if (this.state.toggle_settings.job_number === true) {
        $('.column-type-job-number').show();
        toggleSettingsJobNumber = true;
      }
      else {
        $('.column-type-job-number').hide();
        toggleSettingsJobNumber = false;
      }
      if (this.state.toggle_settings.assigned_to === true) {
        $('.column-type-assigned-to').show();
        toggleSettingsAssignedto = true;
      }
      else {
        $('.column-type-assigned-to').hide();
        toggleSettingsAssignedto = false;
      }
      if (this.state.toggle_settings.company === true) {
        $('.column-type-company').show();
        toggleSettingsCompany = true;
      }
      else {
        $('.column-type-company').hide();
        toggleSettingsCompany = false;
      }
      if (this.state.toggle_settings.original_company === true) {
        $('.column-type-original-company').show();
        toggleSettingsOriginalCompany = true;
      }
      else {
        $('.column-type-original-company').hide();
        toggleSettingsOriginalCompany = false;
      }
      if (this.state.toggle_settings.subcontracted_by_company === true) {
        $('.column-type-subcontracted-by-company').show();
        toggleSettingsSubcontractedByCompany = true;
      }
      else {
        $('.column-type-subcontracted-by-company').hide();
        toggleSettingsSubcontractedByCompany = false;
      }
      if (this.state.toggle_settings.subcontracted_to_company === true) {
        $('.column-type-subcontracted-to-company').show();
        toggleSettingsSubcontractedToCompany = true;
      }
      else {
        $('.column-type-subcontracted-to-company').hide();
        toggleSettingsSubcontractedToCompany = false;
      }

      if (this.state.toggle_settings.required_pickup === true) {
          $('.column-type-required-pickup').show();
          toggleSettingsRequiredPickup = true;
      }
      else {
        $('.column-type-required-pickup').hide();
        toggleSettingsRequiredPickup = false;
      }
      if (this.state.toggle_settings.required_dropoff === true) {
        $('.column-type-required-dropoff').show();
        toggleSettingsRequiredDropoff = true;
      }
      else {
        $('.column-type-required-dropoff').hide();
        toggleSettingsRequiredDropoff = false;
      }
      if (this.state.toggle_settings.scheduled_pickup === true) {
        $('.column-type-scheduled-pickup').show();
        toggleSettingsScheduledPickup = true;
      }
      else {
        $('.column-type-scheduled-pickup').hide();
        toggleSettingsScheduledPickup = false;
      }

      if (this.state.toggle_settings.scheduled_dropoff === true) {
        $('.column-type-scheduled-dropoff').show();
        toggleSettingsScheduledDropoff = true;
      }
      else {
        $('.column-type-scheduled-dropoff').hide();
        toggleSettingsScheduledDropoff = false;
      }


      if (this.state.toggle_settings.reg === true) {
        $('.column-type-reg').show();
        toggleSettingsReg = true;
      }
      else {
        $('.column-type-reg').hide();
        toggleSettingsReg= false;
      }

      if (this.state.toggle_settings.vehicle_on_site === true) {
        $('.column-type-vehicle-on-site').show();
        toggleSettingsVehicleOnSite = true;
      }
      else {
        $('.column-type-vehicle-on-site').hide();
        toggleSettingsVehicleOnSite = false;
      }

      if (this.state.toggle_settings.customer === true) {
        $('.column-type-customer').show();
        toggleSettingsCustomer = true;
      }
      else {
        $('.column-type-customer').hide();
        toggleSettingsCustomer = false;
      }
      if (this.state.toggle_settings.customer_job_number === true) {
        $('.column-type-customer-job-number').show();
        toggleSettingsCustomerJobNumber = true;
      }
      else {
        $('.column-type-customer-job-number').hide();
        toggleSettingsCustomerJobNumber = false;
      }
      if (this.state.toggle_settings.customer_order_number === true) {
        $('.column-type-customer-order-number').show();
        toggleSettingsCustomerOrderNumber = true;
      }
      else {
        $('.column-type-customer-order-number').hide();
        toggleSettingsCustomerOrderNumber = false;
      }

      if (this.state.toggle_settings.pickup_from === true) {
        $('.column-type-pickup-from').show();
        toggleSettingsPickupFrom= true;
      }
      else {
        $('.column-type-pickup-from').hide();
        toggleSettingsPickupFrom = false;
      }
      if (this.state.toggle_settings.pickup_town_city === true) {
        $('.column-type-pickup-town-city').show();
        toggleSettingsPickupTownCity = true;
      }
      else {
        $('.column-type-pickup-town-city').hide();
        toggleSettingsPickupTownCity = false;
      }
      if (this.state.toggle_settings.pickup_postcode === true) {
        $('.column-type-pickup-postcode').show();
        toggleSettingsPickupPostcode = true;
      }
      else {
        $('.column-type-pickup-postcode').hide();
        toggleSettingsPickupPostcode = false;
      }

      if (this.state.toggle_settings.dropoff_to === true) {
        $('.column-type-dropoff-to').show();
        toggleSettingsDropoffTo = true;
      }
      else {
        $('.column-type-dropoff-to').hide();
        toggleSettingsDropoffTo = false;
      }
      if (this.state.toggle_settings.dropoff_town_city === true) {
        $('.column-type-dropoff-town-city').show();
        toggleSettingsDropoffTownCity = true;
      }
      else {
        $('.column-type-dropoff-town-city').hide();
        toggleSettingsDropoffTownCity = false;
      }
      if (this.state.toggle_settings.dropoff_postcode === true) {
        $('.column-type-dropoff-postcode').show();
        toggleSettingsDropoffPostcode = true;
      }
      else {
        $('.column-type-dropoff-postcode').hide();
        toggleSettingsDropoffPostcode = false;
      }

      if (this.state.toggle_settings.driver === true) {
        $('.column-type-driver').show();
        toggleSettingsDriver = true;
      }
      else {
        $('.column-type-driver').hide();
        toggleSettingsDriver = false;
      }

      if (this.state.toggle_settings.status === true) {
        $('.column-type-status').show();
        toggleSettingsDriverStatus = true;
      }
      else {
        $('.column-type-status').hide();
        toggleSettingsDriverStatus = false;
      }

      if (this.state.toggle_settings.distance_in_miles === true) {
        $('.column-type-distance-in-miles').show();
        toggleSettingsMiles = true;
      }
      else {
        $('.column-type-distance-in-miles').hide();
        toggleSettingsMiles = false;
      }

      if (this.state.toggle_settings.estimated_duration === true) {
        $('.column-type-estimated-duration').show();
        toggleSettingsEstimatedDuration = true;
      }
      else {
        $('.column-type-estimated-duration').hide();
        toggleSettingsEstimatedDuration = false;
      }

      if (this.state.toggle_settings.job_price === true) {
        $('.column-type-job-price').show();
        toggleSettingsJobPrice = true;
      }
      else {
        $('.column-type-job-price').hide();
        toggleSettingsJobPrice = false;
      }

      if (this.state.toggle_settings.driver_price === true) {
        $('.column-type-driver-price').show();
        toggleSettingsDriverPrice = true;
      }
      else {
        $('.column-type-driver-price').hide();
        toggleSettingsDriverPrice = false;
      }

      if (this.state.toggle_settings.expenses_price === true) {
        $('.column-type-expenses-price').show();
        toggleSettingsExpensesPrice = true;
      }
      else {
        $('.column-type-expenses-price').hide();
        toggleSettingsExpensesPrice = false;
      }

      if (this.state.toggle_settings.fuel_expenses_price === true) {
        $('.column-type-fuel-expenses-price').show();
        toggleSettingsFuelExpensesPrice = true;
      }
      else {
        $('.column-type-fuel-expenses-price').hide();
        toggleSettingsFuelExpensesPrice = false;
      }

      if (this.state.toggle_settings.admin_fee === true) {
        $('.column-type-admin-fee').show();
        toggleSettingsAdminFee = true;
      }
      else {
        $('.column-type-admin-fee').hide();
        toggleSettingsAdminFee = false;
      }
      if (this.state.toggle_settings.g4_profit === true) {
        $('.column-type-g4-profit').show();
        toggleSettingsG4Profit = true;
      }
      else {
        $('.column-type-g4-profit').hide();
        toggleSettingsG4Profit = false;
      }
      if (this.state.toggle_settings.gross_profit_percentage === true) {
        $('.column-type-gross-profit-percentage').show();
        toggleSettingsGrossProfitPercentage = true;
      }
      else {
        $('.column-type-gross-profit-percentage').hide();
        toggleSettingsGrossProfitPercentage = false;
      }
      if (this.state.toggle_settings.invoice_month === true) {
        $('.column-type-invoice-month').show();
        toggleSettingsInvoiceMonth = true;
      }
      else {
        $('.column-type-invoice-month').hide();
        toggleSettingsInvoiceMonth = false;
      }
      if (this.state.toggle_settings.invoice_number === true) {
        $('.column-type-invoice-number').show();
        toggleSettingsInvoiceNumber = true;
      }
      else {
        $('.column-type-invoice-number').hide();
        toggleSettingsInvoiceNumber = false;
      }
      if (this.state.toggle_settings.subcontract_invoice_number === true) {
        $('.column-type-subcontract-invoice-number').show();
        toggleSettingsSubcontractInvoiceNumber = true;
      }
      else {
        $('.column-type-subcontract-invoice-number').hide();
        toggleSettingsSubcontractInvoiceNumber = false;
      }
      if (this.state.toggle_settings.driver_delivered_date === true) {
        $('.column-type-driver-delivered-date').show();
        toggleSettingsDriverDeliveredDate = true;
      }
      else {
        $('.column-type-driver-delivered-date').hide();
        toggleSettingsDriverDeliveredDate = false;
      }
      if (this.state.toggle_settings.confirmed_on_site === true) {
        $('.column-type-confirmed_on_site').show();
        toggleSettingsConfirmedOnSite = true;
      }
      else {
        $('.column-type-confirmed_on_site').hide();
        toggleSettingsConfirmedOnSite = false;
      }
      if (this.state.toggle_settings.release_code === true) {
        $('.column-type-release_code').show();
        toggleSettingsReleaseCode = true;
      }
      else {
        $('.column-type-release_code').hide();
        toggleSettingsReleaseCode = false;
      }
      if (this.state.toggle_settings.full_details === true) {
        $('.column-type-full-details').show();
        toggleSettingsFullDetails = true;
      }
      else {
        $('.column-type-full-details').hide();
        toggleSettingsFullDetails = false;
      }
    }
    return (
      <form className="columns-toggle">
        <fieldset>
          <div className="columns-toggle-options">

            <label htmlFor="hide-job-number">
              <input type="checkbox"
                     id="hide-job-number"
                     checked={toggleSettingsJobNumber}
                     onChange={() => {
                       $('.column-type-job-number').fadeToggle();
                       this.toggleColumn(
                         'job_number');
                     }
                     } />
              Job Number
            </label>

            <label htmlFor="hide-assigned-to">
              <input type="checkbox"
                     id="hide-assigned-to"
                     checked={toggleSettingsAssignedto}
                     onChange={() => {
                       $('.column-type-assigned-to').fadeToggle();
                       this.toggleColumn(
                         'assigned_to');
                     }
                     } />
              Assigned To
            </label>

            <label htmlFor="hide-company">
              <input type="checkbox"
                     id="hide-company"
                     checked={toggleSettingsCompany}
                     onChange={() => {
                       $('.column-type-company').fadeToggle();
                       this.toggleColumn(
                         'company');
                     }
                     } />
              Company
            </label>

            <label htmlFor="hide-original-company">
              <input type="checkbox"
                     id="hide-original-company"
                     checked={toggleSettingsOriginalCompany}
                     onChange={() => {
                       $('.column-type-original-company').fadeToggle();
                       this.toggleColumn(
                         'original_company');
                     }
                     } />
              Original Company
            </label>

            <label htmlFor="hide-subcontracted-by-company">
              <input type="checkbox"
                     id="hide-subcontracted-by-company"
                     checked={toggleSettingsSubcontractedByCompany}
                     onChange={() => {
                       $('.column-type-subcontracted-by-company').fadeToggle();
                       this.toggleColumn(
                         'subcontracted_by_company');
                     }
                     } />
              Subcontracted By Company
            </label>

            <label htmlFor="hide-subcontracted-to-company">
              <input type="checkbox"
                     id="hide-subcontracted-to-company"
                     checked={toggleSettingsSubcontractedToCompany}
                     onChange={() => {
                       $('.column-type-subcontracted-to-company').fadeToggle();
                       this.toggleColumn(
                         'subcontracted_to_company');
                     }
                     } />
              Subcontracted To Company
            </label>



            <label htmlFor="hide-required-pickup">
              <input type="checkbox"
                     id="hide-required-pickup"

                     checked={toggleSettingsRequiredPickup}

                     onChange={() => {
                       $('.column-type-required-pickup').fadeToggle();
                       this.toggleColumn(
                         'required_pickup');
                     }
                     } />
              Required Pickup
            </label>
            <label htmlFor="hide-required-dropoff">
              <input type="checkbox"
                     id="hide-required-dropoff"
                     checked={toggleSettingsRequiredDropoff}
                     onChange={() => {
                       $('.column-type-required-dropoff').fadeToggle();
                       this.toggleColumn(
                         'required_dropoff');
                     }
                     } />
              Required Dropoff
            </label>
            <label htmlFor="hide-scheduled-pickup">
              <input type="checkbox"
                     id="hide-scheduled-pickup"
                     checked={toggleSettingsScheduledPickup}
                     onChange={() => {
                       $('.column-type-scheduled-pickup').fadeToggle();
                       this.toggleColumn(
                         'scheduled_pickup');
                     }
                     } />
              Scheduled Pickup
            </label>
            <label htmlFor="hide-scheduled-dropoff">
              <input type="checkbox"
                     id="hide-scheduled-dropoff"
                     checked={toggleSettingsScheduledDropoff}
                     onChange={() => {
                       $('.column-type-scheduled-dropoff').fadeToggle();
                       this.toggleColumn(
                         'scheduled_dropoff');
                     }
                     } />
              Scheduled Dropoff
            </label>

            <label htmlFor="hide-reg">
              <input type="checkbox"
                     id="hide-reg"
                     checked={toggleSettingsReg}
                     onChange={() => {
                       $('.column-type-reg').fadeToggle();
                       this.toggleColumn(
                         'reg');
                     }
                     } />
              Reg
            </label>

            <label htmlFor="hide-vehicle-on-site">
              <input type="checkbox"
                     id="hide-vehicle-on-site"
                     checked={toggleSettingsVehicleOnSite}
                     onChange={
                       () => {
                         $('.column-type-vehicle-on-site').fadeToggle();
                         this.toggleColumn(
                           'vehicle_on_site'
                         );
                       }
                     }
              />
              Vehicle On Site
            </label>

            <label htmlFor="hide-customer">
              <input type="checkbox"
                     id="hide-customer"
                     checked={toggleSettingsCustomer}
                     onChange={() => {
                       $('.column-type-customer').fadeToggle();
                       this.toggleColumn(
                         'customer');
                     }
                     } />
              Customer
            </label>
            
            <label htmlFor="hide-customer-job-number">
              <input type="checkbox"
                     id="hide-customer-job-number"
                     checked={toggleSettingsCustomerJobNumber}
                     onChange={() => {
                       $('.column-type-customer-job-number').fadeToggle();
                       this.toggleColumn('customer_job_number');
                     }
                     } />
              Customer Job Number
            </label>

            <label htmlFor="hide-customer-order-number">
              <input type="checkbox"
                     id="hide-customer-order-number"
                     checked={toggleSettingsCustomerOrderNumber}
                     onChange={() => {
                       $('.column-type-customer-order-number').fadeToggle();
                       this.toggleColumn('customer_order_number');
                     }
                     } />
              Customer Order Number
            </label>


            <label htmlFor="hide-pickup-from">
              <input type="checkbox"
                     id="hide-pickup-from"
                     checked={toggleSettingsPickupFrom}
                     onChange={() => {
                       $('.column-type-pickup-from').fadeToggle();
                       this.toggleColumn(
                         'pickup_from');
                     }
                     } />
              Pickup From
            </label>

            <label htmlFor="hide-pickup-town-city">
              <input type="checkbox"
                     id="hide-pickup-town-city"
                     checked={toggleSettingsPickupTownCity}
                     onChange={() => {
                       $('.column-type-pickup-town-city').fadeToggle();
                       this.toggleColumn(
                         'pickup_town_city');
                     }
                     } />
              Pickup Town/City
            </label>

            <label htmlFor="hide-pickup-postcode">
              <input type="checkbox"
                     id="hide-pickup-postcode"
                     checked={toggleSettingsPickupPostcode}
                     onChange={() => {
                       $('.column-type-pickup-postcode').fadeToggle();
                       this.toggleColumn(
                         'pickup_postcode');
                     }
                     } />
              Pickup Postcode
            </label>


            <label htmlFor="hide-dropoff-to">
              <input type="checkbox"
                     id="hide-dropoff-to"
                     checked={toggleSettingsDropoffTo}
                     onChange={() => {
                       $('.column-type-dropoff-to').fadeToggle();
                       this.toggleColumn(
                         'dropoff_to');
                     }
                     } />
              Dropoff To</label>

            <label htmlFor="hide-dropoff-town-city">
              <input type="checkbox"
                     id="hide-dropoff-town-city"
                     checked={toggleSettingsDropoffTownCity}
                     onChange={() => {
                       $('.column-type-dropoff-town-city').fadeToggle();
                       this.toggleColumn(
                         'dropoff_town_city');
                     }
                     } />
              Dropoff Town/City
            </label>

            <label htmlFor="hide-dropoff-postcode">
              <input type="checkbox"
                     id="hide-dropoff-postcode"
                     checked={toggleSettingsDropoffPostcode}
                     onChange={() => {
                       $('.column-type-dropoff-postcode').fadeToggle();
                       this.toggleColumn(
                         'dropoff_postcode');
                     }
                     } />
              Dropoff Postcode
            </label>

            <label htmlFor="hide-driver">
              <input type="checkbox"
                     id="hide-driver"
                     checked={toggleSettingsDriver}
                     onChange={() => {
                       $('.column-type-driver').fadeToggle();
                       this.toggleColumn(
                         'driver');
                     }
                     } />
              Driver
            </label>


            <label htmlFor="hide-status">
              <input type="checkbox"
                     id="hide-status"
                     checked={toggleSettingsDriverStatus}
                     onChange={() => {
                       $('.column-type-status').fadeToggle();
                       this.toggleColumn(
                         'status');
                     }
                     } />
              Driver Status
            </label>


            <label htmlFor="hide-distance-in-miles">
              <input type="checkbox"
                     id="hide-distance-in-miles"
                     checked={toggleSettingsMiles}
                     onChange={() => {
                       $('.column-type-distance-in-miles').fadeToggle();
                       this.toggleColumn(
                         'distance_in_miles');
                     }
                     } />
              Miles
            </label>


            <label htmlFor="hide-estimated-duration">
              <input type="checkbox"
                     id="hide-estimated-duration"
                     checked={toggleSettingsEstimatedDuration}
                     onChange={() => {
                       $('.column-type-estimated-duration').fadeToggle();
                       this.toggleColumn(
                         'estimated_duration');
                     }
                     } />
              Estimated Duration
            </label>



            <label htmlFor="hide-job-price">
              <input type="checkbox"
                     id="hide-job-price"
                     checked={toggleSettingsJobPrice}
                     onChange={() => {
                       $('.column-type-job-price').fadeToggle();
                       this.toggleColumn(
                         'job_price');
                     }
                     } />
              Job Price
            </label>
            <label htmlFor="hide-driver-price">
              <input type="checkbox"
                     id="hide-driver-price"
                     checked={toggleSettingsDriverPrice}
                     onChange={() => {
                       $('.column-type-driver-price').fadeToggle();
                       this.toggleColumn(
                         'driver_price');
                     }
                     } />
              Driver Price
            </label>

            <label htmlFor="hide-expenses-price">
              <input type="checkbox"
                     id="hide-expenses-price"
                     checked={toggleSettingsExpensesPrice}
                     onChange={() => {
                       $('.column-type-expenses-price').fadeToggle();
                       this.toggleColumn(
                         'expenses_price');
                     }
                     } />
              Expenses Price
            </label>


            <label htmlFor="hide-fuel-expenses-price">
              <input type="checkbox"
                     id="hide-fuel-expenses-price"
                     checked={toggleSettingsFuelExpensesPrice}
                     onChange={() => {
                       $('.column-type-fuel-expenses-price').fadeToggle();
                       this.toggleColumn(
                         'fuel_expenses_price');
                     }
                     } />
              Fuel Expenses Price
            </label>

            <label htmlFor="hide-admin-fee">
              <input type="checkbox"
                     id="hide-admin-fee"
                     checked={toggleSettingsAdminFee}
                     onChange={() => {
                       $('.column-type-admin-fee').fadeToggle();
                       this.toggleColumn(
                         'admin_fee');
                     }
                     } />
              Admin Fee
            </label>

            <label htmlFor="hide-g4-profit">
              <input type="checkbox"
                     id="hide-g4-profit"
                     checked={toggleSettingsG4Profit}
                     onChange={() => {
                       $('.column-type-g4-profit').fadeToggle();
                       this.toggleColumn(
                         'g4_profit');
                     }
                     } />
              Profit
            </label>

            <label htmlFor="hide-gross-profit">
              <input type="checkbox"
                     id="hide-gross-profit"
                     checked={toggleSettingsGrossProfitPercentage}
                     onChange={() => {
                       $('.column-type-gross-profit-percentage').fadeToggle();
                       this.toggleColumn(
                         'gross_profit_percentage');
                     }
                     } />
             Gross Profit (%)
            </label>

            <label htmlFor="hide-invoice-month">
              <input type="checkbox"
                     id="hide-invoice-month"
                     checked={toggleSettingsInvoiceMonth}
                     onChange={() => {
                       $('.column-type-invoice-month').fadeToggle();
                       this.toggleColumn(
                         'invoice_month');
                     }
                     } />
              Invoice Month
            </label>

            <label htmlFor="hide-invoice-number">
              <input type="checkbox"
                     id="hide-invoice-number"
                     checked={toggleSettingsInvoiceNumber}
                     onChange={() => {
                       $('.column-type-invoice-number').fadeToggle();
                       this.toggleColumn(
                         'invoice_number');
                     }
                     } />
              Invoice Number
            </label>

            <label htmlFor="hide-subcontract-invoice-number">
              <input type="checkbox"
                     id="hide-subcontract-invoice-number"
                     checked={toggleSettingsSubcontractInvoiceNumber}
                     onChange={() => {
                       $('.column-type-subcontract-invoice-number').fadeToggle();
                       this.toggleColumn(
                         'subcontract_invoice_number');
                     }
                     } />
             Subcontract Invoice Number
            </label>
            
            <label htmlFor="hide-driver_delivered_date">
              <input type="checkbox"
                     id="hide-driver_delivered_date"
                     checked={toggleSettingsDriverDeliveredDate}
                     onChange={() => {
                       $('.column-type-driver-delivered-date').fadeToggle();
                       this.toggleColumn(
                         'driver_delivered_date');
                     }
                     } />
              Driver Delivered Date
            </label>

            <label htmlFor="hide-confirmed_on_site">
              <input type="checkbox"
                     id="hide-confirmed_on_site"
                     checked={toggleSettingsConfirmedOnSite}
                     onChange={() => {
                       $('.column-type-confirmed_on_site').fadeToggle();
                       this.toggleColumn(
                         'confirmed_on_site');
                     }
                     } />
              Confirmed on site
            </label>

            <label htmlFor="hide-release_code">
              <input type="checkbox"
                     id="hide-release_code"
                     checked={toggleSettingsReleaseCode}
                     onChange={() => {
                       $('.column-type-release_code').fadeToggle();
                       this.toggleColumn(
                         'release_code');
                     }
                     } />
              Release Code
            </label>

            <label htmlFor="hide-full-details">
              <input type="checkbox"
                     id="hide-full-details"
                     checked={toggleSettingsFullDetails}
                     onChange={() => {
                       $('.column-type-full-details').fadeToggle();
                       this.toggleColumn(
                         'full_details');
                     }
                     } />
              Full Details
            </label>
          </div>
          <button className="btn btn-sml btn-default"
                  onClick={(e) => {
                    this.toggleColumnsToggleOptions(e)}
                  }>
            <i className="fa fa-columns"></i> Columns
          </button>
        </fieldset>
      </form>
    )
  }
}
